var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vxe-grid',{ref:"refTable",attrs:{"columns":_vm.tableColumn,"data":_vm.tableData,"min-height":30,"rowConfig":{
      isCurrent: false
    }},scopedSlots:_vm._u([{key:"default_remark",fn:function(){return [_c('span',{staticClass:"c-blue"},[_vm._v("物料采购中")])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }